/**
 * A intencao de cotar hotel — o unico dado que atravessa da DSC para a extensao.
 *
 * ELA CARREGA O CONTATO, NAO A COTACAO. E a diferenca importa: quando o
 * vendedor clica em Hotel, a cotacao ainda NAO EXISTE, e nem poderia —
 * `Quote.create` recusa destino vazio e exige as duas datas, e nesse momento
 * ninguem sabe qual hotel sera escolhido nem para quando.
 *
 * A cotacao nasce na VOLTA, com os dados da oferta real: cidade do hotel,
 * check-in e check-out do proprio documento do fornecedor. Mesmo padrao do
 * Aereo, que so cria a cotacao depois que o voo foi escolhido.
 *
 * O que viaja sao IDENTIFICADORES DE CONTEXTO, nunca dado de negocio
 * duplicado: para qual contato o vendedor esta comecando uma oportunidade de
 * hotel. Nome, telefone e historico ficam onde sempre estiveram.
 *
 * A intencao EXPIRA e e CONSUMIDA. Sem isso, uma intencao esquecida na terca
 * mandaria um hotel para o contato errado na quinta, em silencio.
 */

export const FONTE = 'dsc-cotacao';
export const TIPO = 'intencao-de-hotel';

// Duas horas. Tempo de sobra para uma pesquisa, curto o bastante para que uma
// intencao esquecida nao sobreviva ao expediente.
export const VALIDADE_MS = 2 * 60 * 60 * 1000;

/**
 * A mensagem publicada para a extensao. NADA alem de identidade e prazo.
 */
export function mensagemDeIntencao(contactId, agora = Date.now()) {
  if (!contactId) return null;
  return {
    fonte: FONTE,
    tipo: TIPO,
    contact_id: String(contactId),
    criada_em: new Date(agora).toISOString(),
    expira_em: new Date(agora + VALIDADE_MS).toISOString(),
  };
}

/**
 * A composicao de hospedes so pode ser automatica quando ela e representavel.
 *
 * O fornecedor informa o TOTAL de hospedes, nunca a divisao. `para_bloco`
 * recusa adivinhar, e essa decisao continua certa: em hotel, uma crianca muda
 * preco, quarto e regra de ocupacao. Entao a tela de volta pergunta a divisao
 * uma vez, com o total travado pelo que o fornecedor cotou.
 */
export function divisaoValida(adultos, criancas, total) {
  const a = Number(adultos);
  const c = Number(criancas);
  if (!Number.isInteger(a) || !Number.isInteger(c)) return false;
  if (a < 1 || c < 0) return false;
  // Total ausente significa que o fornecedor NAO deu um total legivel: o
  // `distribution` do HotelDO e uma codificacao de ocupacao, e so as vezes
  // e um numero. Sem total nao ha o que conferir. Conferir contra um numero
  // inventado e pior que nao conferir — foi um "2359" assim que recusou uma
  // cotacao legitima em producao.
  if (total === null || total === undefined || total === '') return true;
  const t = Number(total);
  if (!Number.isInteger(t) || t < 1) return true;
  return a + c === t;
}
